import {WellBottomProfile, WellSurfaceDataShape, PlateType} from '../../constants/dataEnum';

export const DEFAULT_OTHER_PLATE_LABEL = 'Other Plates';

export const WellLabel = {
  WELL_1: '1',
  WELL_8: '8',
  WELL_12: '12',
  WELL_24: '24_c',
  WELL_48: '48_c',
  WELL_96: '96',
  WELL_384: '384',
  WELL_IFC_192_24: '192.24',
  WELL_IFC_96_96: '96.96',
  WELL_IFC_48_48: '48.48',
  WELL_SPEAR_BIO: '24.5',
};

// key is wellLabel, value is wellType for alignToDeckInsertWithOffset API
export const WellType = {
  WELL_1: 1,
  WELL_8: 8,
  WELL_12: 12,
  WELL_24: 24,
  WELL_48: 48,
  WELL_96: 96,
  WELL_384: 384,
  WELL_IFC_192_24: 384,
  WELL_IFC_96_96: 384,
  WELL_IFC_48_48: 1001, // Special for IFC 48.48
  WELL_SPEAR_BIO: 1002,
};

export const TroughWellList = [WellLabel.WELL_1, WellLabel.WELL_8, WellLabel.WELL_12];

export const MicroplateWellList = [
  WellLabel.WELL_1,
  WellLabel.WELL_8,
  WellLabel.WELL_12,
  WellLabel.WELL_24,
  WellLabel.WELL_48,
  WellLabel.WELL_96,
  WellLabel.WELL_384,
];

export const IFCWellList = [WellLabel.WELL_IFC_192_24, WellLabel.WELL_IFC_48_48, WellLabel.WELL_IFC_96_96];

export const OtherPlatesList = [...IFCWellList, WellLabel.WELL_SPEAR_BIO];

export const DefaultPlateConfiguration = {
  [WellLabel.WELL_IFC_192_24]: {
    plateType: PlateType.IFC,
    wellBottomProfile: WellBottomProfile.CONYCAL,
    wellShape: WellSurfaceDataShape.CIRCLE,
  },
  [WellLabel.WELL_IFC_96_96]: {
    plateType: PlateType.IFC,
    wellBottomProfile: WellBottomProfile.CONYCAL,
    wellShape: WellSurfaceDataShape.RECTANGLE,
  },
  [WellLabel.WELL_IFC_48_48]: {
    plateType: PlateType.IFC,
    wellBottomProfile: WellBottomProfile.CONYCAL,
    wellShape: WellSurfaceDataShape.CIRCLE,
  },
  [WellLabel.WELL_SPEAR_BIO]: {
    plateType: PlateType.SPEAR_BIO,
    wellBottomProfile: WellBottomProfile.CONYCAL,
    wellShape: WellSurfaceDataShape.CIRCLE,
    columnPitch: 9,
    rowPitch: 9,
  },
};

/**
 * Can be use to change the type from backend from number to string
 */
export const PlateTypeName = {
  3: PlateType.MICROPLATE,
  4: PlateType.IFC,
  5: PlateType.SPEAR_BIO,
};

// properties description:
// properties will be shown on all plates by default unless any of the optional props are defined

// required props:

// propertiesLabel: label <string>
// key: key for plateTypeEditorState object <string>

// optional props:

// shownOnMicroplatesOnly: shown on microplates only <bool>
// shownOnTroughOnly: shown on trough plates only <bool>

// shownOn: shown on specified plates <array>
// disabledOn: disabled on specified plates <array>
// disabledAll: disabled on all plates <bool>
// allExcluding: shown to all plates excluding specified plates <array>
// showOnPlates: shown on specified plate types <array>

export const ListsOfPlateProperties = [
  {
    propertiesLabel: 'Well Diameter',
    key: 'length',
    shownOn: [WellLabel.WELL_96, WellLabel.WELL_384],
  },
  {propertiesLabel: 'Well Diameter (X-Size)', key: 'length', shownOnTroughOnly: true},
  {propertiesLabel: 'Well Diameter (Y-Size)', key: 'width', shownOnTroughOnly: true},
  {propertiesLabel: 'Column Origin', key: 'columnOrigin'},
  {
    propertiesLabel: 'Column Pitch',
    key: 'columnPitch',
    allExcluding: [WellLabel.WELL_1, WellLabel.WELL_8, WellLabel.WELL_IFC_192_24],
    disabledOn: [
      WellLabel.WELL_12,
      WellLabel.WELL_96,
      WellLabel.WELL_384,
      WellLabel.WELL_IFC_48_48,
      WellLabel.WELL_IFC_96_96,
      WellLabel.WELL_SPEAR_BIO,
    ],
  },
  {
    propertiesLabel: 'Column Pitch Sample',
    key: 'columnPitch',
    shownOn: [WellLabel.WELL_IFC_192_24],
    disabledAll: true,
  },
  {
    propertiesLabel: 'Column Pitch Assay - Sample',
    key: 'colPitchAssaySample',
    shownOn: [WellLabel.WELL_IFC_192_24],
    disabledOn: [WellLabel.WELL_IFC_192_24],
  },
  {propertiesLabel: 'Row Origin', key: 'rowOrigin'},
  {
    propertiesLabel: 'Row Pitch',
    key: 'rowPitch',
    allExcluding: [WellLabel.WELL_1, WellLabel.WELL_12],
    disabledOn: [
      WellLabel.WELL_12,
      WellLabel.WELL_96,
      WellLabel.WELL_384,
      WellLabel.WELL_IFC_48_48,
      WellLabel.WELL_IFC_96_96,
      WellLabel.WELL_SPEAR_BIO,
    ],
  },
  {propertiesLabel: 'Plate Height', key: 'height'},
  {propertiesLabel: 'Well Depth', key: 'depth', shownOnMicroplatesOnly: true},
  {
    propertiesLabel: "Inlet's Depth",
    key: 'depth',
    showOnPlates: [PlateType.IFC, PlateType.SPEAR_BIO],
  },
  {
    propertiesLabel: "Inlet's Diameter",
    key: 'length',
    showOnPlates: [PlateType.IFC, PlateType.SPEAR_BIO],
  },
  {
    propertiesLabel: 'Trough Depth',
    key: 'troughDepth',
    shownOn: [WellLabel.WELL_IFC_192_24],
    disabledOn: [WellLabel.WELL_IFC_192_24],
  },
];

export const defaultPlatesIdList = [1, 2];

export const PlateProperties = {
  INLET_DEPTH: "Inlet's Depth",
  INLET_DIAMETER: "Inlet's Diameter",
  ROW_PITCH: 'Row Pitch',
  COLUMN_PITCH: 'Column Pitch',
};

export const CHERRY_PICK_ONLY_LABWARES = [WellLabel.WELL_24, WellLabel.WELL_48];

export const SPEARBIO_TROUGH_COLUMN = [1, 2, 3];

export const PLATE_PROPERTIES_VALUE_PRECISION = 3;
